import React from "react";
import { CheckCircle, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OmOss() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const benefits = ["Avancerad AI-driven navigation", "Full redundans i sensorsystem", "Optimerad ruttplanering i realtid", "Sömlös integration med Tesla Network"];
  return <section data-section-id="56755" id="om-robotaxi" ref={ref} className={`py-20 md:py-28 bg-background text-foreground overflow-hidden transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image Column */}
          <div className={`relative group transition-all duration-700 delay-200 ${isVisible ? "translate-x-0 opacity-100" : "-translate-x-10 opacity-0"}`}>
            <div className="relative rounded-[3px] overflow-hidden shadow-lg border border-border bg-muted aspect-[4/3] lg:aspect-square">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1592905/img/balance_work_team_on_roof.png" alt="Närbild på Tesla Waymo sensor-suite och autonom teknologi" className="object-cover w-full h-full transform transition-transform duration-700 group-hover:scale-105" />
              {/* Floating Badge */}
              <div className="absolute bottom-6 left-6 right-6 bg-background/95 backdrop-blur-sm p-6 rounded-[3px] border border-border shadow-md">
                <div className="flex items-center gap-4">
                  <div className="bg-primary/10 p-3 rounded-full text-primary">
                    <CheckCircle className="w-8 h-8" />
                  </div>
                  <div>
                    <p className="text-sm font-sans font-medium text-muted-foreground uppercase tracking-wider">
                      Teknologi
                    </p>
                    <p className="text-lg font-default font-bold text-foreground">
                      Precision och Säkerhet
                    </p>
                  </div>
                </div>
              </div>
            </div>
            {/* Decorative element */}
            <div className="absolute -z-10 top-10 -left-10 w-full h-full border-2 border-primary/20 rounded-[3px] hidden lg:block" />
          </div>

          {/* Text Column */}
          <div className={`flex flex-col space-y-8 transition-all duration-700 delay-400 ${isVisible ? "translate-x-0 opacity-100" : "translate-x-10 opacity-0"}`}>
            <div className="space-y-4">
              <span className="inline-block py-1 px-3 rounded-full bg-primary/10 text-primary text-sm font-sans font-semibold tracking-wide">
                OM ROBOTAXI
              </span>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold tracking-tight text-primary leading-[1.1]">
                Framtidens mobilitet är <span className="text-foreground">redan här</span>
              </h2>
              <p className="text-lg font-sans text-muted-foreground leading-relaxed">
                Vi leder utvecklingen inom robotaxi-tjänster och autonom körning. Genom att kombinera avancerad sensorteknik med artificiell intelligens skapar vi en säkrare och mer effektiv transportlösning för alla i urbana miljöer.
              </p>
              <p className="text-base font-sans text-muted-foreground leading-relaxed">
                Vårt mål är att demokratisera tillgången till säker mobilitet. Oavsett om du är en enskild fordonsägare som vill optimera din investering eller en operatör som skalar upp en flotta, erbjuder vi de mest avancerade verktygen för framgång.
              </p>
            </div>

            <ul className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((benefit, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                  <CheckCircle className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                  <span className="text-foreground font-sans font-medium text-sm md:text-base">
                    {benefit}
                  </span>
                </li>)}
            </ul>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button asChild size="lg" className="w-full sm:w-auto text-base font-default font-semibold shadow-md">
                <Link to="/RobotaxiPage">
                  Läs mer om robotaxi
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="w-full sm:w-auto text-base font-default font-semibold border-primary/20 hover:bg-primary/5 hover:text-primary">
                <Link to="/BecomeOperatorPage">
                  Bli operatör <ArrowRight className="ml-2 w-4 h-4" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}